import { render, staticRenderFns } from "./account-sync-modal.vue?vue&type=template&id=747efcda&scoped=true&"
import script from "./account-sync-modal.vue?vue&type=script&lang=ts&"
export * from "./account-sync-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747efcda",
  null
  
)

export default component.exports